import React from 'react';

import Section from 'react-scale/components/elements/section';
import FeatureTitle from 'react-scale/components/pages/open-datasets/FeatureTitle';

const CarSetup = ({ iconColors, overtitle, title, text, children, caseColor }) => (
  <Section id="car-setup">
    <FeatureTitle
      iconSVG={<Icon colors={iconColors} />}
      overtitle={overtitle}
      title={title}
      subtitle={text}
      caseColor={caseColor}
    />
    {children}
  </Section>
);

CarSetup.defaultProps = {
  overtitle: { text: 'Car Setup' },
  title: 'Vehicle, Sensor and Camera Details'
};

export default CarSetup;

const Icon = ({ colors }) => (
  <svg viewBox="0 0 144 144">
    <path
      d="M72 144C111.765 144 144 111.765 144 72C144 32.2355 111.765 0 72 0C32.2355 0 0 32.2355 0 72C0 111.765 32.2355 144 72 144Z"
      fill="black"
    />
    <path
      d="M72 77C74.7614 77 77 74.7614 77 72C77 69.2386 74.7614 67 72 67C69.2386 67 67 69.2386 67 72C67 74.7614 69.2386 77 72 77Z"
      fill={colors[0]}
    />
    <path
      d="M72 32C69.24 32 67 34.24 67 37V47C67 49.76 69.24 52 72 52C74.76 52 77 49.76 77 47V37C77 34.24 74.76 32 72 32Z"
      fill={colors[1]}
    />
    <path
      d="M72 92C69.24 92 67 94.24 67 97V107C67 109.76 69.24 112 72 112C74.76 112 77 109.76 77 107V97C77 94.24 74.76 92 72 92Z"
      fill={colors[1]}
    />
    <path
      d="M47 67H37C34.24 67 32 69.24 32 72C32 74.76 34.24 77 37 77H47C49.76 77 52 74.76 52 72C52 69.24 49.76 67 47 67Z"
      fill={colors[1]}
    />
    <path
      d="M107 67H97C94.24 67 92 69.24 92 72C92 74.76 94.24 77 97 77H107C109.76 77 112 74.76 112 72C112 69.24 109.76 67 107 67Z"
      fill={colors[1]}
    />
    <path
      d="M49.6808 42.5998L42.6008 35.5198C40.6408 33.5598 37.4808 33.5598 35.5208 35.5198C33.5608 37.4798 33.5608 40.6398 35.5208 42.5998L42.6008 49.6798C44.5608 51.6398 47.7208 51.6398 49.6808 49.6798C51.6408 47.7198 51.6408 44.5598 49.6808 42.5998Z"
      fill={colors[2]}
    />
    <path
      d="M49.6808 96.4002C47.7208 94.4402 44.5608 94.4402 42.6008 96.4002L35.5208 103.48C33.5608 105.44 33.5608 108.6 35.5208 110.56C37.4808 112.52 40.6408 112.52 42.6008 110.56L49.6808 103.48C51.6408 101.52 51.6408 98.3402 49.6808 96.4002Z"
      fill={colors[0]}
    />
    <path
      d="M110.54 35.5398C108.58 33.5798 105.42 33.5798 103.46 35.5398L96.3997 42.5998C94.4397 44.5598 94.4397 47.7198 96.3997 49.6798C98.3597 51.6398 101.52 51.6398 103.48 49.6798L110.56 42.5998C112.48 40.6598 112.48 37.4798 110.54 35.5398Z"
      fill={colors[0]}
    />
    <path
      d="M110.54 103.46L103.46 96.3802C101.5 94.4202 98.3402 94.4202 96.3802 96.3802C94.4202 98.3402 94.4202 101.5 96.3802 103.46L103.46 110.54C105.42 112.5 108.58 112.5 110.54 110.54C112.48 108.58 112.48 105.42 110.54 103.46Z"
      fill={colors[2]}
    />
  </svg>
);
